<template>
  <div>
    <v-card class="alert-assessment-teach" outlined>
      <v-card-title>
        <v-icon color="warning" class="mr-2">mdi-bell-alert</v-icon>
        แจ้งเตือนรอบการประเมินครูผู้ช่วย
        <v-spacer></v-spacer>

        <v-btn color="success"  to="/college/assistant_teacher">รายงานผลการประเมิน</v-btn>
      </v-card-title>
      <v-card-text>
        <v-alert
          v-if="upcomingEvaluations.length"
          type="warning"
          border="left"
          colored-border
          elevation="2"
          class="mb-4"
        >
          <div v-for="(item, i) in upcomingEvaluations" :key="i">
            <v-icon left color="warning">mdi-calendar-clock</v-icon>
            {{ item.mt_frist_name }} {{ item.mt_last_name }}
            <span class="error--text font-weight-bold">
              (รอบที่ {{ item.nextRound }} : {{ item.nextDate | dateTH }})
            </span>
          </div>
        </v-alert>
        <apexchart
          v-if="chartOptions && chartSeries"
          type="bar"
          height="300"
          :options="chartOptions"
          :series="chartSeries"
        />

        <apexchart
          v-if="branchChartOptions && branchChartSeries"
          type="bar"
          height="300"
          :options="branchChartOptions"
          :series="branchChartSeries"
        />
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
export default {
  name: "AlertAssessmentTeach",
  components: {
    apexchart: VueApexCharts
  },
  data() {
    return {
      ApiKey: "HRvec2021",
      users: [],
      userSession: JSON.parse(localStorage.getItem("user")) || 0,
      manage_assistant_teachers: [],
      headers: [
        { text: "รหัสบัตรประชาชน", align: "left", value: "mt_id_card" },
        { text: "คำนำหน้าชื่อ", align: "left", value: "mt_title_s" },
        { text: "ชื่อ", align: "left", value: "mt_frist_name" },
        { text: "สกุล", align: "left", value: "mt_last_name" },
        { text: "เลขที่ตำแหน่ง", align: "center", value: "mt_id_position" },
        {
          text: "เสนอรายชื่อกรรมการประเมิน",
          align: "center",
          value: "mt_committe_file"
        },
        {
          text: "ประกาศคำสั่งแต่งตั้งกรรมการฯจาก สอศ.",
          align: "center",
          value: "pertem_assistantFileIpastatus"
        },
        { text: "ใบประกอบวิชาชีพ", align: "center", value: "pt_licence" },
        { text: "การประเมิน", align: "center", value: "evaluate_s" },
        { text: "ครั้งที่ 1", align: "center", value: "mt_time_1_score" },
        { text: "ครั้งที่ 2", align: "center", value: "mt_time_2_score" },
        { text: "ครั้งที่ 3", align: "center", value: "mt_time_3_score" },
        { text: "ครั้งที่ 4", align: "center", value: "mt_time_4_score" },
        { text: "สาขาวิชา", align: "left", value: "name_branch" },
        { text: "วันเดือนปีเกิด", align: "center", value: "mt_brith_day" }
      ],
      chartOptions: null,
      chartSeries: null,
      branchChartOptions: null,
      branchChartSeries: null
    };
  },
  computed: {
    // หารายการที่ต้องประเมินใน 7 วันข้างหน้า
    upcomingEvaluations() {
      const today = new Date();
      const sevenDays = 7 * 24 * 60 * 60 * 1000;
      return this.manage_assistant_teachers
        .map(item => {
          // สมมติว่ามีฟิลด์ nextEvaluationDate และ nextRound
          let nextDate = item.month6
            ? new Date(item.month6)
            : null;
          let diff = nextDate ? nextDate - today : null;
          return nextDate && diff > 0 && diff <= sevenDays
            ? { ...item, nextDate: nextDate, nextRound: item.nextRound }
            : null;
        })
        .filter(Boolean);
    }
  },
  async mounted() {
    await this.userQuery();
    await this.manage_assistant_teacherQueryAll();
    this.prepareChart();
  },
  methods: {
    prepareMonthChart() {
  // กำหนด label และ field ที่เกี่ยวข้องกับเดือน
  const monthLabels = ["6 เดือน", "12 เดือน", "18 เดือน", "24 เดือน"];
  const monthFields = [
    "mt_time_1_date", // สมมติรอบที่ 1 คือ 6 เดือน
    "mt_time_2_date", // รอบที่ 2 คือ 12 เดือน
    "mt_time_3_date", // รอบที่ 3 คือ 18 เดือน
    "mt_time_4_date"  // รอบที่ 4 คือ 24 เดือน
  ];

  // นับจำนวนครูที่มีการประเมินในแต่ละเดือน
  const monthCounts = monthFields.map(field =>
    this.manage_assistant_teachers.filter(item => item[field] && item[field] !== "").length
  );

  this.monthChartOptions = {
    chart: { id: "month-assessment" },
    xaxis: { categories: monthLabels },
    colors: ["#B3151B"],
    title: { text: "จำนวนการประเมินแต่ละช่วงเดือน", align: "center" },
    legend: { show: false }
  };
  this.monthChartSeries = [
    {
      name: "จำนวนการประเมิน",
      data: monthCounts
    }
  ];
},
    async userQuery() {
      let result = await this.$http.post("admin.php", {
        user_name: this.userSession.user_name,
        ApiKey: "HRvec2021"
      });
      this.users = result.data;
    },
    async manage_assistant_teacherQueryAll() {
      let result = await this.$http.post("manage_assistant_teacher.php", {
        ApiKey: this.ApiKey,
        mt_college_code: this.users.user_name,
        fastQ: "Ok"
      });
      this.manage_assistant_teachers = result.data;
    },
    prepareChart() {
      const roundLabels = [
        "ครั้งที่ 1",
        "ครั้งที่ 2",
        "ครั้งที่ 3",
        "ครั้งที่ 4"
      ];
      const roundFields = [
        "mt_time_1_score",
        "mt_time_2_score",
        "mt_time_3_score",
        "mt_time_4_score"
      ];
      // นับจำนวนที่ประเมินแล้วและยังไม่ได้ประเมินในแต่ละรอบ
      const doneCounts = roundFields.map(
        field =>
          this.manage_assistant_teachers.filter(
            item => item[field] !== null && item[field] !== "0.00"
          ).length
      );
      const notDoneCounts = roundFields.map(
        (field, idx) => this.manage_assistant_teachers.length - doneCounts[idx]
      );
      this.chartOptions = {
        chart: { id: "assessment-rounds", stacked: true },
        xaxis: { categories: roundLabels },
        colors: ["#B3151B", "#424242"],
        title: { text: "เปรียบเทียบสถานะการประเมินแต่ละรอบ", align: "center" },
        legend: { position: "top" },
        plotOptions: { bar: { horizontal: false } }
      };
      this.chartSeries = [
        {
          name: "ประเมินแล้ว",
          data: doneCounts
        },
        {
          name: "ยังไม่ได้ประเมิน",
          data: notDoneCounts
        }
      ];
    }
  },
  filters: {
    dateTH(val) {
      if (!val) return "";
      const d = new Date(val);
      return `${d.getDate()}/${d.getMonth() + 1}/${d.getFullYear() + 543}`;
    }
  }
};
</script>

<style scoped>
.alert-assessment-teach {
  margin: 16px 0;
}
</style>
